import { FC, useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled, { css } from 'styled-components'

import { IconRecordLarge, IconUploadCloud } from '@/components/common/Icons'

import { RecordModal } from './RecordModal'
import { UploadedOrRecorded } from './UploadedOrRecorded'
import { UploadDropzone } from './UploadDropzone'

export const AudioScript: FC<{
  audioScriptUrl?: string
  audioScriptFile?: File
  onChangeAudioScriptFile: (audioScriptFile?: File) => void
}> = ({ audioScriptUrl, audioScriptFile, onChangeAudioScriptFile }) => {
  const { t } = useTranslation('common')

  const [isOpenedRecordModal, setIsOpenedRecordModal] = useState(false)

  return (
    <AudioScriptContainer>
      {!audioScriptUrl && !audioScriptFile ? (
        <>
          <Upload onChangeAudioScriptFile={onChangeAudioScriptFile}>
            <IconUploadCloud />
            <span className="message">
              {t('Choose a file or drag it here')}
            </span>
            <span className="description">
              {t('MP3, WAV files: max 100mb, 5 min')}
            </span>
          </Upload>

          <Record
            onClick={() => {
              setIsOpenedRecordModal(true)
            }}
          >
            <IconRecordLarge />
            <span className="message">{t('Click to Record Audio')}</span>
            <span className="description">{t('Up to 5 min')}</span>
          </Record>
        </>
      ) : (
        <UploadedOrRecorded
          audioScriptUrl={audioScriptUrl}
          audioScriptFile={audioScriptFile}
          onDelete={() => onChangeAudioScriptFile(undefined)}
        />
      )}

      <RecordModal
        isOpened={isOpenedRecordModal}
        onClose={() => setIsOpenedRecordModal(false)}
        onRecorded={onChangeAudioScriptFile}
      />
    </AudioScriptContainer>
  )
}

const AudioScriptContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  height: 100%;
  border: 1px solid #cccccc;
  border-top: 0;
  border-radius: 0 0 6px 6px;

  padding: 8px;

  box-sizing: border-box;

  font-family: Noto Sans CJK;
  font-size: 12px;
  line-height: 16px;
`

/**
 * span.message
 * span.description
 */
const uploadAreaCommonStyle = css`
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border: 1px solid #444444;
  border-radius: 6px;

  transition: background-color 0.3s;

  cursor: pointer;

  span.description {
    color: #777777;
  }

  &:hover {
    background-color: #f4f4f4;
  }
`

/**
 * span.message
 * span.description
 */
const Upload = styled(UploadDropzone)`
  ${uploadAreaCommonStyle}

  border-style: dashed;
`

/**
 * span.message
 * span.description
 */
const Record = styled.div`
  ${uploadAreaCommonStyle}

  border-style: solid;
`
